import { type JSX } from "react";
import { cn, formatdDate, parseDateString } from "../../lib/utils";
import { TooltipCell } from "../table/TooltipCell";
import { IconMaterial } from "../shared/iconMaterial/IconMaterial";
import { TPrescription, usePrescriptions } from "../../context/PrescriptionProvider";
import Badge from "../shared/ui/Badge";


type BodyTableProps = {
  id?: string | null;
  rows: TPrescription[];
  handleRowClick: (prescription: TPrescription) => void
  isPagination?: boolean;
  isLoadingSendInvitation: boolean;
  onRowClick?: (id: string) => void;
  handleClickInviteButton: (id: string) => void;
};

export const BodyTablePrescriptions = ({
  rows,
  handleRowClick,
}: BodyTableProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black text-sm text-primary-light",
    "align-middle min-w-0",
  );

  const { selectedPrescription } = usePrescriptions()

  return (
    <>
      {rows.map((prescription, index) => {
        return (
          <tr
            key={index}
            className={`${selectedPrescription?.prescription_id === prescription?.prescription_id ? 'bg-background-light-gray' : ''}`}
              >
            <td
              onClick={() => handleRowClick(prescription)}
              className={cn(
                baseCellClassName,
                "relative overflow-hidden cursor-pointer group",
                selectedPrescription?.prescription_id === prescription?.prescription_id ? "border-l-[2px] border-primeblue" : ""
              )}
            >
              <div className="rounded-l-lg flex items-center">
                <span className="truncate group-hover:text-primeblue">
                  {prescription.prescription_id && "P-" + prescription.prescription_id}
                </span>
                <IconMaterial
                  filled
                  icon="chevron_right"
                  className="cursor-pointer hidden group-hover:block group-hover:text-primeblue"
                  size={16}
                />
              </div>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={
                formatdDate(prescription.created_stamp) || '-'}
              />
            </td>

            <td className={cn(baseCellClassName)}>
              <Badge
                status={prescription.status}
              />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={prescription.his_created_date} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={prescription.his_hospital_pharmacy_stock_id} />
            </td>
          </tr>
        );
      })}
    </>
  );
};
